export default {
  companyStatisticMetadata: {
    employeesOnAdaptation: 'Employees on adaptation',
    employeesCount: 'Employees count',
    availableLicenses: 'Available licenses',
    started: 'Started',
    lastSend: 'Last send',
    nearestSend: 'The nearest send',
    employeesEvaluated: 'Evaluated employees',
    motivation: 'Motivation',
    teamRoles: 'Personal structure and team roles',
    numOfSurveys: 'Number of surveys sent',
    numOfAnswers: 'Number of answers to questions',
    createSurveys: 'Create surveys and assign them<br />to employees',
    noData: 'No data',
    imageAlt: 'Empty Pulse Survey Chart',
    evaluationProgress: 'Evaluation progress',
    notStarted: 'Not started',
    inProgress: 'In progress',
    finished: 'Finished',
    withRoadmaps: 'Employees with development plans',
    totalTargets: 'total targets',
    efficiency: 'efficiency',
    testsFinished: 'Tests finished',
  },
};
